import {
  ComparisonChartControlsProps,
  ComparisonChartControls,
} from "@/components/ComparisonChartTable";
import { FC, PropsWithChildren } from "react";

export const ComparisonChartControlsBlock: FC<
  PropsWithChildren<ComparisonChartControlsProps>
> = ({ children, ...props }) => (
  <ComparisonChartControls {...props}>{children}</ComparisonChartControls>
);
